import { render, staticRenderFns } from "./PrivacyPolicy.vue?vue&type=template&id=25a60588&scoped=true&"
import script from "./PrivacyPolicy.vue?vue&type=script&lang=js&"
export * from "./PrivacyPolicy.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyPolicy.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PrivacyPolicy.vue?vue&type=style&index=1&id=25a60588&lang=scss&rel=text%2Fcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a60588",
  null
  
)

export default component.exports